export default __webpack_public_path__ + "static/media/element_spec_71.68485618.webp";